import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { useFormatMessage } from '../../intl/intlHooks';
import { cartTotalItemsMessages } from './orderSummaryMessages';

import cartIcon from './images/cart.inline.svg';


export const CartTotalItems = ({ quantity }) => {
    const formatMessage = useFormatMessage();
    const cartHeading = formatMessage(cartTotalItemsMessages.cartHeading);
    const cartCountMessage = formatMessage(cartTotalItemsMessages.cartLabel, { cartCount: quantity });

    return (
        <Fragment>
            <h1 className="cart-column__heading" aria-label={cartHeading}>{cartHeading}</h1>
            <h2 className="cart-column__heading" aria-live="assertive" aria-label={cartCountMessage}>
                <img aria-hidden="true" src={cartIcon} alt="Cart Icon" className="order-confirmation-cart-icon" />
                <span>{cartCountMessage}</span>
            </h2>
        </Fragment>
    );
};

CartTotalItems.defaultProps = {
    quantity: 0
};

CartTotalItems.propTypes = {
    quantity: PropTypes.number
};
